<template>

<div class="main list-view">

	<div class="sub-header">
		<div class="input-with-control">
			<input type="search" ref="search_term" v-model="filters.search_term" placeholder="Search..." @search="getList()" v-focus>
			<div class="button action input-go" @click="getList()"><i class="fas fa-search"></i></div>
		</div>
		<div class="controls">
			<pagination :paging="paging" @updatePage="goToPage"></pagination>
		</div>
	</div>

	<div class="filters">
        <label>Filter by...</label>
        <ul class="checkbox-group">
			<li>
				<span :class="['pointer', 'far', filters.all_products ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('all_products')"></span>
				<label>Is Set for All Products</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.specific_products ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('specific_products')"></span>
				<label>Is Set for Specific Products</label>
			</li>
			<li>
				<span :class="['pointer', 'far', filters.has_dates ? 'fa-check-square' : 'fa-square']" @click="toggleFilter('has_dates')"></span>
				<label>Has Dates</label>
			</li>
		</ul>

		<div class="divider"></div>

		<div class="button neutral" @click="clearFilters()">Clear Filters</div>
		<div class="button action" @click="searchManufacturers = true">Add</div>
		<div :class="['button', gettingExport ? 'disabled' : 'neutral']" @click="doExport()">Export CSV</div>

		<div class="message">{{ exportMessage }}</div>

	</div>

	<div class="list">
	    <div v-if="list.length == 0" class="empty-list">
	        This list is empty
	    </div>
	    <table v-else class="data-list" cellpadding="0" cellspacing="0">
			<thead>
				<tr>
					<th class="list">Manufacturer</th>
					<th class="list">Start Date</th>
					<th class="list">End Date</th>
					<th class="list center">All</th>
					<th class="list right">Product UPC</th>
					<th class="list right">MAP</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(item, index) in list" class="clickable-list-item" @click="assignItem(item)">
					<td class="list">{{ item.description }}</td>
					<td class="list">{{ $formatDate(item.start_date) }}</td>
                    <td class="list">{{ $formatDate(item.end_date) }}</td>
					<td class="list center"><i v-if="item.all_products == 1" class="fa fa-check" /></td>
					<td class="list right">{{ item.upc }}</td>
					<td class="list right">{{ item.map }}</td>
				</tr>
			</tbody>
		</table>

	</div>

	<iframe id="download" src="" style="display: none;"></iframe>

    <div class="modal" v-if="searchManufacturers">
		<div class="inner">
			<h2>Search Manufacturers</h2>
			<div class="content">

                <div class="input-with-control">
                    <input type="text" v-model="filters.manufacturer" placeholder="Search..." @keyup.enter="getFilterList('manufacturer')">
                    <div class="button action input-go" @click="getFilterList('manufacturer')"><i class="fas fa-search"></i></div>
                </div>

                <ul v-if="modalList.length > 0" class="search-list">
					<li class="clickable-list-item" v-for="(listItem, index) in modalList" @click="assignItem(listItem)">{{ listItem.description || listItem.full_name }}</li>
				</ul>
				<div v-if="modalMessage" class="empty">{{ modalMessage }}</div>
			</div>
			<div class="controls">
				<div class="button cancel" @click="searchManufacturers = false">Cancel</div>
			</div>
		</div>
	</div>

	<map-policy-detail v-if="showDetail" :listDetail="listDetail" @searchProduct="setSearchProducts" @backToList="backToList" :key="'product_id_' + listDetail.product_id" />

	<product-search v-if="searchProducts" singleProduct="true" :manufacturer="manufacturer" @assignProduct="assignProduct" @cancel="searchProducts = false" />

</div>

</template>

<script>
import Loading from '@/components/Loading.vue'
import NumberInput from '@/components/NumberInput.vue'
import LabelRequired from '@/components/LabelRequired.vue'
import ProductSearch from '@/components/ProductSearch.vue'
import MapPolicyDetail from '@/components/MapPolicyDetail.vue'
export default {
	name: 'map-policies',
    components: {
        'loading': Loading,
		'number-input': NumberInput,
		'label-required': LabelRequired,
		'product-search': ProductSearch,
		'map-policy-detail': MapPolicyDetail
    },
	data() {
		return {
            loading: false,
			filters: {},
			filterMessage: '',
			priceOverrideDepartments: [],
			priceOverrideTypes: [],
			priceOverrideFlags: [],
			list: [],
			paging: {},
			showDetail: false,
			listDetail: {},
			gettingExport: false,
			exporting: false,
			exportMessage: '',
			manufacturer: {},
			searchProducts: false,
			searchManufacturers: false,
            modalList: [],
            modalMessage: ''
		}
	},
	created() {
        if (!this.getAdministratorFlag) {
            this.$router.push('/')
        }
		this.clearFilters()
	},
	methods: {
		clearFilters() {
			this.filters = {
				page: 1,
				search_term: '',
				manufacturer_id: '',
				all_products: '',
				specific_product: '',
				do_export: 0,
			}
			this.getList()
		},
		getList() {
			if (this.loading) { return }
			this.loading = true
			this.apiCall({ destination: 'get_list_manufacturer_map_policies', data: this.filters }).then(obj => {
				this.loading = false
				if (this.filters.do_export) {
					this.filters.do_export = 0
					var outputFile = obj.file_name
					// accommodate live server filecache latency
					setTimeout(() => {
						document.getElementById("download").src = "//" + document.location.hostname + "/download.php?file_name=" + obj.file_name + "&output_file_name=" + outputFile
						this.gettingExport = false
						this.exportMessage = ''
					}, 1500)
				} else {
					this.list = obj.list
					if (obj.paging) {
						this.paging = obj.paging
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		goToPage(page) {
			this.filters.page = page
			this.getList()
		},
		assignItem(item) {
            if (!item.product_id) {
                item.all_products = 1
            }
            this.searchManufacturers = false
			this.saveMessage = ''
			this.saving = false
			this.confirmDelete = false
			this.listDetail = item
			this.showDetail = true
		},
		getFilterList() {
			if (!this.filters.manufacturer) { return false }
			this.apiCall({ destination: 'get_list_manufacturers', data: { search_term: this.filters.manufacturer } } ).then(obj => {
				if (obj.status == 'success') {
					if (obj.status == 'error') {
						this.modalMessage = obj.message
					} else if (obj.manufacturers.length > 1) {
						this.modalMessage = ''
						this.modalList = obj.manufacturers
					} else if (obj.manufacturers.length == 1) {
						this.assignItem(obj.manufacturers[0])
                        this.searchManufacturers = false
					} else {
						this.modalMessage = 'No matching manufacturers found'
					}
				}
			}).catch(err => {
				console.log(err)
			})
		},
		addItem() {
			this.showDetail = false,
			this.listDetail = {}
			this.searchProducts = true
		},
		setSearchProducts(manufacturer) {
			this.manufacturer = manufacturer
			this.searchProducts = true
		},
		assignProduct(product) {
			this.searchProducts = false
			this.listDetail.product_id = product.product_id
			this.listDetail.product = product.description
			this.listDetail.upc = product.upc
		},
		backToList(updateRequired) {
			this.listDetail = {}
			this.searchProducts = false
			this.showDetail = false
			this.saving = false
			this.searching = false
			this.confirmDelete = false
			this.saveMessage = ''
			this.searchMessage = ''
			if (updateRequired) {
				this.getList()
			}
		},
		doExport() {
			if (this.gettingExport) {
				return false
			}
			this.gettingExport = true
			this.exportMessage = 'Generating CSV for ' + this.list.length + ' items...'
			this.filters.product_id = ''
			this.filters.do_export = true
			this.getList()
		}
	}
}
</script>
